import DateClass from '@/app/module/date'

class Session {
  /* account */
  public setAccountData (accountData: string) {
    sessionStorage.setItem('accountData', accountData)
  }
  public getAccountData () {
    return sessionStorage.getItem('accountData')
  }

  /* field */
  // 圃場一覧を構成するためのデータ
  public setFieldData (fieldData: string) {
    sessionStorage.setItem('fieldData', fieldData)
  }
  public getFieldData () {
    return sessionStorage.getItem('fieldData')
  }

  // デフォルトの圃場一覧
  public setAllFieldData (allFieldData: string) {
    sessionStorage.setItem('allFieldData', allFieldData)
  }
  public getAllFieldData () {
    return sessionStorage.getItem('allFieldData')
  }

  // グルーピングの保持
  public setChoiceGrouping (grouping: string) {
    sessionStorage.setItem('choiceGrouping', grouping)
  }
  public getChoiceGrouping () {
    return sessionStorage.getItem('choiceGrouping')
  }

  // グルーピングの保持（モーダル用）
  public setChoiceModalGrouping (grouping: string) {
    sessionStorage.setItem('choiceModalGrouping', grouping)
  }
  public getChoiceModalGrouping () {
    return sessionStorage.getItem('choiceModalGrouping')
  }

  // 圃場の詳細データを構成するためのデータ
  public setFieldDetailsData (data: string, id: string) {
    sessionStorage.setItem(`details_area_${id}`, data)
  }
  public getFieldDetailsData (id: string) {
    return sessionStorage.getItem(`details_area_${id}`)
  }

  // 圃場の詳細データを構成するためのデータ（モーダル用）
  public setModalFieldDetailsData (data: string, id: string) {
    sessionStorage.setItem(`details_modal_${id}`, data)
  }
  public getModalFieldDetailsData (id: string) {
    return sessionStorage.getItem(`details_modal_${id}`)
  }

  // 直前に選択した圃場IDを保持
  public setChoiceFieldId (id: string) {
    sessionStorage.setItem('choiceFiledId', id)
  }
  public getChoiceFieldId () {
    return sessionStorage.getItem('choiceFiledId')
  }

  // 品種コピー作成
  public setCopyVarietyData (data: any) {
    sessionStorage.setItem('varietyCopyData', data)
  }
  public getCopyVarietyData () {
    return sessionStorage.getItem('varietyCopyData')
  }
  // 品種生育コピー作成
  public setCopyVarietyGrowthData (data: any) {
    sessionStorage.setItem('varietyGrowthCopyData', data)
  }
  public getCopyVarietyGrowthData () {
    return sessionStorage.getItem('varietyGrowthCopyData')
  }

  /* fieldDetails */
  // 紐づいている目標のID
  public setVarietyId (id: string) {
    sessionStorage.setItem('varietyId', id)
  }
  public getVarietyId () {
    return sessionStorage.getItem('varietyId')
  }

  public setDistrictId (id: string) {
    sessionStorage.setItem('districtId', id)
  }
  public getDistrictId () {
    return sessionStorage.getItem('districtId')
  }

  // 播種日
  public setPlantingDay (val: string) {
    sessionStorage.setItem('plantingDay', val)
  }
  public getPlantingDay () {
    return sessionStorage.getItem('plantingDay')
  }

  // 収穫適期詳細
  public setHarvestDetails (val: string) {
    sessionStorage.setItem('harvestDatails', val)
  }
  public getHarvestDetaisls () {
    return sessionStorage.getItem('harvestDatails')
  }

  // 播種日
  public setHarvestTime (val: string) {
    sessionStorage.setItem('harvestTime', val)
  }
  public getHarvestTime () {
    return sessionStorage.getItem('harvestTime')
  }

  // 収穫適期日
  public setHarvestDate (val: string) {
    sessionStorage.setItem('HarvestDate', val)
  }
  public getHarvestDate () {
    return sessionStorage.getItem('HarvestDate')
  }

  // 実測の収穫ステータス
  public setHarvestStatus (val: number|any) {
    sessionStorage.setItem('harvestStatus', val)
  }
  public getHarvestStatus () {
    return sessionStorage.getItem('harvestStatus')
  }

  // 実測の収穫ステータス変更日
  public setHarvestStatusDay (val: string|any) {
    sessionStorage.setItem('harvestStatusDay', val)
  }
  public getHarvestStatusDay () {
    return sessionStorage.getItem('harvestStatusDay')
  }

  // ステージバーを構成するためのデータ
  public setGrowthStage (val: string) {
    sessionStorage.setItem('growthStage', val)
  }
  public getGrowthStage () {
    return sessionStorage.getItem('growthStage')
  }

  // 中干し
  public setMidsummerDrainage (val: string) {
    sessionStorage.setItem('midsummerDrainage', val)
  }
  public getMidsummerDrainage () {
    return sessionStorage.getItem('midsummerDrainage')
  }

  // 追肥情報
  public setFertilizer (val: string) {
    sessionStorage.setItem('fertilizer', val)
  }
  public getFertilizer () {
    return sessionStorage.getItem('fertilizer')
  }

  // アラート情報
  public setPlantingAlerts (val: string) {
    sessionStorage.setItem('plantingAlerts', val)
  }
  public getPlantingAlerts () {
    return sessionStorage.getItem('plantingAlerts')
  }

  // 茎数単位
  public setStemNumberType (val: string) {
    sessionStorage.setItem('stemNumberType', val)
  }
  public getStemNumberType () {
    return sessionStorage.getItem('stemNumberType')
  }

  // 作付けID
  public setPlantingId (id: string) {
    sessionStorage.setItem('plantingId', id)
  }
  public getPlantingId () {
    return sessionStorage.getItem('plantingId')
  }

  // グラフの実測値を構成するためのデータ
  public setGraphData (graphData: string) {
    sessionStorage.setItem('graphData', graphData)
  }
  public getGraphData () {
    return sessionStorage.getItem('graphData')
  }

  // グラフの実測値を構成するためのデータ
  public setAllGraphData (graphData: string) {
    sessionStorage.setItem('allGraphData', graphData)
  }
  public getAllGraphData () {
    return sessionStorage.getItem('allGraphData')
  }

  // グラフの実測値を構成するためのデータ
  public setDviGraphData (graphData: string) {
    sessionStorage.setItem('dviGraphData', graphData)
  }
  public getDviGraphData () {
    return sessionStorage.getItem('dviGraphData')
  }

  // デフォルトのグラフデータ
  public setDefaultGraphData (graphData: string) {
    sessionStorage.setItem('defaultGraphData', graphData)
  }
  public getDefaultGraphData () {
    return sessionStorage.getItem('defaultGraphData')
  }

  // 実測グラフの最終日
  public setGraphLastDay (val: string|any) {
    sessionStorage.setItem('graphLastDay', val)
  }
  public getGraphLastDay () {
    return sessionStorage.getItem('graphLastDay')
  }

  // 予測グラフを構成するためのデータ
  public setPredictionData (predictionData: string) {
    sessionStorage.setItem('predictionData', predictionData)
  }
  public getPredictionData () {
    return sessionStorage.getItem('predictionData')
  }

  // 目標グラフを構成するためのデータ
  public setMasterData (masterData: string) {
    sessionStorage.setItem('masterData', masterData)
  }
  public getMasterData () {
    return sessionStorage.getItem('masterData')
  }

  // 目標グラフを構成するためのデータ
  public setIsDviGraph (is_dvi_graph: string) {
    sessionStorage.setItem('isDviGraph', is_dvi_graph)
  }
  public getIsDviGraph () {
    return sessionStorage.getItem('isDviGraph')
  }

  // 水位目標グラフを構成するためのデータ
  public setMasterWaterLevelData (masterWaterLevelData: string) {
    sessionStorage.setItem('masterWaterLevelData', masterWaterLevelData)
  }
  public getMasterWaterLevelData () {
    return sessionStorage.getItem('masterWaterLevelData')
  }

  // 水位目標グラフを構成するためのデータ
  public setMasterWaterControls (MasterWaterControls: string) {
    sessionStorage.setItem('MasterWaterControls', MasterWaterControls)
  }
  public getMasterWaterControls () {
    return sessionStorage.getItem('MasterWaterControls')
  }

  // 比較グラフを構成するためのデータ
  public setComparisonData (comparisonData: string) {
    sessionStorage.setItem('comparisonData', comparisonData)
  }
  public getComparisonData () {
    return sessionStorage.getItem('comparisonData')
  }

  // 比較グラフを構成するためのデータ
  public setAllComparisonData (comparisonData: string) {
    sessionStorage.setItem('allComparisonData', comparisonData)
  }
  public getAllComparisonData () {
    return sessionStorage.getItem('allComparisonData')
  }

  // 比較の目標データ
  public getComparisonPredictionData () {
    return sessionStorage.getItem('comparisonPrediction')
  }
  public setComparisonPredictionData (comparisonPrediction: string) {
    sessionStorage.setItem('comparisonPrediction', comparisonPrediction)
  }

  // 比較のステージデータ
  public getComparisonStageData () {
    return sessionStorage.getItem('comparisonStage')
  }
  public setComparisonStageData (comparisonStage: string) {
    sessionStorage.setItem('comparisonStage', comparisonStage)
  }

  // 生育データを構成するためのデータ
  public setSensorData (data: string, id: string) {
    sessionStorage.setItem(`sensor_${id}`, data)
  }
  public getSensorData (id: string) {
    return sessionStorage.getItem(`sensor_${id}`)
  }

  // 水遵守率表示用データ
  public setWaterComplianceRateData (data: string, id: string) {
    sessionStorage.setItem(`waterComplianceRate_${id}`, data)
  }
  public getWaterComplianceRateData (id: string) {
    return sessionStorage.getItem(`waterComplianceRate_${id}`)
  }

  // 画像データ
  public getImageRecords () {
    return sessionStorage.getItem('imageRecords')
  }
  public setImageRecords (imageRecords: string) {
    sessionStorage.setItem('imageRecords', imageRecords)
  }

  // あい作 任意アイコンデータ
  public getPointIcons () {
    return sessionStorage.getItem('pointIcons')
  }
  public setPointIcons (pointIcons: string) {
    sessionStorage.setItem('pointIcons', pointIcons)
  }

  // リスクデータ
  public getRiskRecords () {
    return sessionStorage.getItem('riskRecords')
  }
  public setRiskRecords (riskRecords: string) {
    sessionStorage.setItem('riskRecords', riskRecords)
  }

  // 収穫ステータスデータ
  public getHarvestStatusData () {
    return sessionStorage.getItem('harvestStatusData')
  }
  public setHarvestStatusData (harvestStatusData: string) {
    sessionStorage.setItem('harvestStatusData', harvestStatusData)
  }

  // 収穫ステータス更新日データ
  public getHarvestStatusUpdateData () {
    return sessionStorage.getItem('harvestStatusUpdateData')
  }
  public setHarvestStatusUpdateData (harvestStatusUpdateData: string) {
    sessionStorage.setItem('harvestStatusUpdateData', harvestStatusUpdateData)
  }

  // 圃場管理一覧データ（区画設定のマップに登録済みの圃場表示用）
  public getFieldPolygonData () {
    return sessionStorage.getItem('fieldPolygonData')
  }
  public setFieldPolygonData (fieldPolygonData: string) {
    sessionStorage.setItem('fieldPolygonData', fieldPolygonData)
  }

  /* キャッシュの期限 */
  public async clearSensorCache () {
    for (var key in sessionStorage) {
      if (key.split('_')[0] === 'sensor') {
        // ローカルストレージのタイムスタンプ
        let data = new Date(JSON.parse(sessionStorage[key])[0].timestamp)
        // 期限日(次の日の7:00)
        let timeLimit = new Date('' + data.getFullYear() + '-' + DateClass.toDoubleDigits(data.getMonth() + 1) + '-' + DateClass.toDoubleDigits(data.getDate() + 1) + 'T07:00:00')
        // 今
        let now = new Date()

        if (now > timeLimit) {
          await sessionStorage.removeItem(key)
        }
      }
    }
  }

  /* キャッシュの期限 */
  public async clearWaterComplianceRateCache () {
    for (var key in sessionStorage) {
      if (key.split('_')[0] === 'waterComplianceRate') {
        // ローカルストレージのタイムスタンプ
        let data = new Date(JSON.parse(sessionStorage[key])[0].timestamp)
        // 期限日(次の日の7:00)
        let timeLimit = new Date('' + data.getFullYear() + '-' + DateClass.toDoubleDigits(data.getMonth() + 1) + '-' + DateClass.toDoubleDigits(data.getDate() + 1) + 'T07:00:00')
        // 今
        let now = new Date()

        if (now > timeLimit) {
          await sessionStorage.removeItem(key)
        }
      }
    }
  }

  public async clearDetailsCache () {
    for (var key in sessionStorage) {
      if (key.split('_')[0] === 'details') {
        // ローカルストレージのタイムスタンプ
        let data = new Date(JSON.parse(sessionStorage[key])[0].timestamp)
        // 期限日(次の日の7:00)
        let timeLimit = new Date('' + data.getFullYear() + '-' + DateClass.toDoubleDigits(data.getMonth() + 1) + '-' + DateClass.toDoubleDigits(data.getDate() + 1) + 'T07:00:00')
        // 今
        let now = new Date()

        if (now > timeLimit) {
          await sessionStorage.removeItem(key)
        }
      }
    }
  }
}
export default new Session()
